<template>
    <div class="case-list">
        <div class="list-wrap">
            <pull-to :distance-index="3" :top-config="TOP_DEFAULT_CONFIG" :bottom-config="BOTTOM_DEFAULT_CONFIG"
                     :top-load-method="downRefresh" :bottom-load-method="upRefresh" :is-bottom-bounce="isBottomBounce">
                <ul id="sorllHight">
                    <!-- <div v-if="!isNotData"> -->
                    <div v-if="noArrPro">
                        <div class="not-data2" v-if="nMore">暂时还没有数据哦~</div>
                        <div class="more" v-if="nMore">更多推荐</div>
                        <li v-for="(item, index) in arrProjectList" :key="index" @click.stop="toDetail(item)">
                            <img v-if="item.project_uuid" src="@/assets/images/koub-icon2.png" class="koub-icon" alt="">
                            <p>
                                {{ item.type }}<span>|</span>{{ item.city + item.community_name + "项目案例" }}
                            </p>
                            <div class="attr">
                                <div class="attr-left">
                                    <p>{{ item.house_area }}</p>
                                    <p>{{ item.house_cate || "暂无" }}</p>
                                    <!-- <div class="tag-list">
                                        <div>{{ item.type }}</div>
                                    </div> -->
                                </div>
                                <div class="attr-right">
                                    <img src="@/assets/images/ant/map/watch.png" alt=""/>
                                    <span>{{ item.views || item.real_views }}</span>
                                </div>
                            </div>
                            <div class="pic-list">
                                <div class="pic-item" v-for="(imgItem, imgIndex) in item.images" :key="imgIndex">
                                    <img v-lazy="imgItem.img_url" alt="" v-if="imgIndex <= 2"/>
                                </div>
                            </div>

                            <div :class="['state-icon', stateStyle(item.status)]"></div>
                        </li>
                        <!-- <div class="dropload-tip" v-if="isToEnd">
                            我是有底线的~
                        </div> -->
                    </div>
                    <div v-if="arrProjectListOther.length">
                        <div class="top_more">
                            <div class="leftBor"></div>
                            <div class="titleMore">更多周边案例</div>
                            <div class="rightBor"></div>
                        </div>
                        <li v-for="(item, index) in arrProjectListOther" :key="index" @click.stop="toDetail(item)">
                            <img v-if="item.project_uuid" src="@/assets/images/koub-icon2.png" class="koub-icon" alt="">
                            <p>
                                {{ item.type }}<span>|</span>{{ item.city + item.community_name + "项目案例" }}
                            </p>
                            <div class="attr">
                                <div class="attr-left">
                                    <p>{{ item.house_area }}</p>
                                    <p>{{ item.house_cate || "暂无" }}</p>
                                    <!-- <div class="tag-list">
                                        <div>{{ item.type }}</div>
                                    </div> -->
                                </div>
                                <div class="attr-right">
                                    <img src="@/assets/images/ant/map/watch.png" alt=""/>
                                    <span>{{ item.views || item.real_views }}</span>
                                </div>
                            </div>
                            <div class="pic-list">
                                <div class="pic-item" v-for="(imgItem, imgIndex) in item.images" :key="imgIndex">
                                    <img v-lazy="imgItem.img_url" alt="" v-if="imgIndex <= 2"/>
                                </div>
                            </div>

                            <div :class="['state-icon', stateStyle(item.status)]"></div>
                        </li>
                    </div>
                    <!-- <div class="not-data" v-else>暂时还没有数据哦~</div> -->
                </ul>
            </pull-to>
        </div>

        <div :class="['search-wrap-mask', bModalEffectMask ? 'fade-in' : 'fade-out']" @click.stop="closeSearchModal()"
             v-show="bModalMaskShow">
            <transition name="collapse-list">
                <div class="search-wrap" v-show="bSearchModalShow" @click.stop>
                    <div class="search">
                        <span>小区名称</span>
                        <input type="text" placeholder="请输入小区名称" @input="searchChange()" v-model="sKeyWord"/>
                    </div>
                    <div class="search-item" v-for="(item, index) in arrSearchConfig" :key="index">
                        <div class="label">{{ item.name }}</div>
                        <div class="tab-list">
                            <div :class="[
                  'tab-item',
                  active(item.checked, tabItem) ? 'active' : '',
                ]" v-for="(tabItem, tabIndex) in item.tabList" :key="tabIndex" @click="tabChange(index, tabItem.code)">
                                {{ tabItem.name }}
                            </div>
                        </div>
                    </div>
                    <div class="btn">
                        <button @click="clearChecked()">清空记录</button>
                        <button @click="closeSearchModal()">确定</button>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
import PullTo from "vue-pull-to";
import {
    getProjectList,
    getProjectListsOther,
    getSearchConfig,
} from "@/js/map.js";

export default {
    name: "allCase2",
    components: {
        PullTo,
    },
    props: {
        isAll: {
            type: Number,
            default: false,
        },
        bSearchModalShow: {
            type: Boolean,
            default: false,
        },
        nCityId: {
            type: Number,
            default: null,
        },
        nLng: {
            type: Number,
            default: null,
            //   default: 115.847463,
        },
        nLat: {
            type: Number,
            default: null,
            //   default: 28.693276,
        },
        nHeight: {
            type: Object,
            default: {},
        },
        nCity: {
            type: String,
            default: {},
        },
    },
    data() {
        return {
            TOP_DEFAULT_CONFIG: {
                pullText: "下拉刷新", // 下拉时显示的文字
                triggerText: "释放更新", // 下拉到触发距离时显示的文字
                loadingText: "加载中...", // 加载中的文字
                doneText: "加载完成", // 加载完成的文字
                failText: "加载失败", // 加载失败的文字
                loadedStayTime: 400, // 加载完后停留的时间ms
                stayDistance: 50, // 触发刷新后停留的距离
                triggerDistance: 70, // 下拉刷新触发的距离
            },
            BOTTOM_DEFAULT_CONFIG: {
                pullText: "上拉加载",
                triggerText: "释放更新",
                loadingText: "加载中...",
                doneText: "加载完成",
                failText: "加载失败",
                noDataText: "已经到底了",
                loadedStayTime: 400,
                stayDistance: 50,
                triggerDistance: 70,
            },
            topMore: false,
            isBottomBounce: true, // 滚动底部是否开启弹性

            sKeyWord: "", // 搜索关键词
            nPage: 0, // 页数

            arrSearchConfig: [
                {
                    multiple: true,
                    checked: [],
                    type: "house_area",
                    name: "房屋面积",
                    tabList: [],
                },
                {
                    multiple: true,
                    checked: [],
                    type: "house_type",
                    name: "房屋类型",
                    tabList: [],
                },
                {
                    multiple: true,
                    checked: [],
                    type: "house_cate",
                    name: "房屋种类",
                    tabList: [],
                },
                {
                    multiple: true,
                    checked: [],
                    type: "antType",
                    name: "产品品类",
                    tabList: [],
                },
                {
                    multiple: true,
                    checked: [],
                    type: "plan",
                    name: "案例进度",
                    tabList: [],
                },
                {
                    multiple: true,
                    checked: [],
                    type: "praise",
                    name: "口碑案例",
                    tabList: [],
                },
                {
                    multiple: true,
                    checked: [],
                    type: "decorate",
                    name: "装修",
                    tabList: [],
                },
            ], // 搜索条件配置

            oAttrValue: {
                houseArea: "",
                houseType: "",
                houseCate: "",
                typeId: "",
                plan: "",
                praise: "",
                decorate: "",
            }, // 搜所条件选中值
            arrProjectListOther: [], //周边案例
            arrProjectList: [], // 项目列表
            isToEnd: false, // 是否到底
            isNotData: true, // 是否有数据
            rimNoData: true, //周边是否有数据
            noArrPro: true,

            bSearchShow: false, // 搜索弹窗显示

            nMore: 0,

            bModalMaskShow: false, // 搜索弹窗显示
            bModalEffectMask: false, // 搜索弹窗mask显示

            timer: null, // 定时器
        };
    },
    filters: {
        subTitle(value) {
            const index = value.lastIndexOf("栋");
            if (!~index) {
                return value;
            } else {
                return value.substring(0, index) + "栋";
            }
        },
    },
    created() {
        if (this.nLng != null) {
            this.getProjectList();
        }

        this.getSearchConfig();
        // if(this.isNotData){
        //     this.arrProjectList = [];
        //     this.nPage = 0;
        //     this.getProjectList()
        // }
    },
    mounted() {
        let sorllId = document.querySelector(".scroll-container");
        sorllId.addEventListener(
            "scroll",
            this.windowScroll(this.handle, 1000, {end: true, begin: true})
        ); //监听页面滚动
    },
    activated() {
        let nHeight = this.$store.state.sorllHeight;
        //  console.log("组件内部", nHeight);
        this.$nextTick(() => {
            let sorllId = document.querySelector(".scroll-container");
            sorllId.scrollTop = nHeight.sorllHeight;
        });
    },
    destroyed() {
        let sorllId = document.querySelector(".scroll-container");
        sorllId.removeEventListener("scroll", this.windowScroll); //销毁滚动事件
    },
    computed: {},
    watch: {
        bSearchModalShow(newValue, oldValue) {
            if (newValue) {
                this.bModalMaskShow = newValue;
                this.bModalEffectMask = newValue;
                document.body.classList.add("dialog"); // 锁定背景，静止滚动
            } else {
                this.bModalEffectMask = newValue;
                setTimeout(() => {
                    this.bModalMaskShow = newValue;
                }, 500);
                document.body.classList.remove("dialog"); // 解除
            }
        },
    },
    methods: {
        //页面滚动事件  节流函数
        windowScroll(func, wait, options = {}) {
            let timeout,
                previous = 0;
            return function () {
                let now = +new Date();
                let remain = wait - (now - previous);
                if (remain < 0) {
                    if (previous === 0 && !options.begin) {
                        previous = now;
                        return;
                    }

                    if (timeout) {
                        clearTimeout(timeout);
                        timeout = null;
                    }

                    previous = now;
                    func.call(this, arguments);
                } else if (!timeout && options.end) {
                    timeout = setTimeout(() => {
                        func.call(this, arguments);
                        timeout = null;
                    }, wait);
                }
            };
        },
        handle() {
            let sorllId = document.querySelector(".scroll-container");
            let sorllHeight = sorllId.scrollTop;
            let objSorllHeight = {
                sorllHeight: sorllHeight,
            };
            this.$store.commit("sorllHeight", objSorllHeight);
        },
        // 案例列表右上角标签
        stateStyle(state) {
            let className = "";
            switch (state) {
                case '已签约':
                    className = "yqy";
                    break;
                case '施工中':
                    className = "sgz";
                    break;
                case '已完工':
                    className = "ywg";
                    break;
            }
            return className;
        },
        // 选中样式
        active(checked, data) {
            return ~checked.findIndex((item) => item === data.code);
        },
        // 选择搜索条件
        tabChange(index, code) {
            const active = this.arrSearchConfig[index].checked.findIndex(
                (item) => item === code
            );
            if (this.arrSearchConfig[index].multiple) {
                // 多选
                if (~active) {
                    this.arrSearchConfig[index].checked.splice(active, 1);
                } else {
                    this.arrSearchConfig[index].checked.push(code);
                }
            } else {
                // 单选
                if (~active) {
                    this.arrSearchConfig[index].checked.splice(active, 1);
                } else {
                    this.arrSearchConfig[index].checked = [code];
                }
            }
            // this.confirm(1)
        },
        // 清空记录
        clearChecked() {
            this.arrSearchConfig.forEach((item) => {
                item.checked = [];
            });
            this.sKeyWord = "";
            this.oAttrValue = {
                houseArea: "",
                houseType: "",
                houseCate: "",
                typeId: "",
                plan: "",
                praise: "",
                decorate: "",
            };
            this.getProjectList();
        },
        // 下拉刷新
        downRefresh(loaded) {
            //  console.log(this.isToEnd, "top");
            this.arrProjectListOther = []; //周边案例
            this.arrProjectList = []; // 项目列表
            this.nPage = 0;
            this.getProjectList(() => {
                loaded("done");
            });
        },
        // 上拉加载
        upRefresh(loaded) {
            if (!this.isToEnd) {
                this.nPage++;
                this.getProjectList(() => {
                    loaded("done");
                });
            } else if (this.rimNoData) {
                 console.log("加载周边",this.nPage);
                this.getProjectListsOther(() => {
                    loaded("done");
                    this.nPage++
                });
                // this.nPage++;
            } else {
                loaded("done");
                this.$toast({
                    message: "已经到底了！",
                    duration: 1200,
                });
            }
        },
        // 关闭搜索弹窗
        closeSearchModal() {
            //  console.log('444')

            this.$emit("closeSchMark")
            this.confirm(1);
            this.$emit("update:bSearchModalShow", false);
        },
        /**
         * 获取分享标识
         * @return {{value: string, key: string}}
         */
        getShareLabel() {
            const url = new URL(location.href);
            // 约定的出口类型 search_key;
            const key = this.$store.state.shareOutKey;
            return {key, value: url.searchParams.get(key)}
        },
        // 进入详情
        toDetail(event) {
            console.log(event,'_____+++++++');
            console.log(this.$route.query,'this.$route.query');
            const that = this;
            const id = event.id;
            var ua = window.navigator.userAgent.toLowerCase();
            const {type, city, community_name, images} = event;
            const img_url = images.length?images[0].img_url:'';
            const img = event.images.length?event.images[0].img_url:'';
            const ut_source = this.$route.query.ut_source;
            const qywxUserId = this.$route.query.qywxUserId;
            let parame = {type, city, community_name, img_url, ut_source, qywxUserId};
            console.log(parame,'parameparameparame');
            let dataSet = encodeURIComponent(JSON.stringify(parame));
            let account_id = event.pro_name //item的数据
            // 版本
            let version = event.version;  //item的数据
            console.log(version,'versionversion');
            const label = this.getShareLabel();
            if (ua.match(/MicroMessenger/i) == "micromessenger") {
                if (ua.match(/WxWork/i) == "wxwork") {
                    if (wx?.miniProgram?.getEnv) {
                        wx.miniProgram.getEnv(function (res) {
                            if (res.miniprogram) {
                                // 小程序环境下逻辑
                                wx.miniProgram.navigateTo({
                                    // url: `/pages/antdetails/index?id=${id}&version=${version}&parame=${dataSet}&acc_id=${account_id}`,
                                    url: `/pages/antdetails/index?id=${id}&version=${version}&acc_id=${account_id}`,
                                });
                            } else {
                                //非小程序环境下逻辑
                                if(version == 1){
                                    that.$router.push({path: "/antdetails/index", query: {id, [label.key]: [label.value], qywxUserId, ut_source: 'ai_heating',acc_id: account_id}});
                                }else{
                                    that.$router.push({path: "/project/detail/construction", query: {id, [label.key]: [label.value], qywxUserId, ut_source: 'ai_heating',acc_id: account_id}});
                                }
                            }
                        });
                    } else {
                        //企业微信环境下
                        if(version == 1){
                            that.$router.push({path: "/antdetails/index", query: {id, [label.key]: [label.value], qywxUserId, ut_source: 'ai_heating',acc_id: account_id}});
                        }else{
                            that.$router.push({path: "/project/detail/construction", query: {id, [label.key]: [label.value], qywxUserId, ut_source: 'ai_heating',acc_id: account_id}});
                        }
                    }
                } else {
                    //判断是否是微信环境
                    //微信环境
                    wx.miniProgram.getEnv(function (res) {
                        if (res.miniprogram) {
                            // 小程序环境下逻辑
                            wx.miniProgram.navigateTo({
                                // url: `/pages/antdetails/index?id=${id}&version=${version}&parame=${dataSet}&acc_id=${account_id}`,
                                url: `/pages/antdetails/index?id=${id}&version=${version}&acc_id=${account_id}`,
                            });
                        } else {
                            //非小程序环境下逻辑
                            that.$router.push({path:version == 2?"/project/detail/construction":"/antdetails/index", query: {id, [label.key]: [label.value], qywxUserId, ut_source: 'ai_heating',acc_id: account_id}});
                        }
                    });
                }
            } else {
                // 非微信环境逻辑
                if(version == 1){
                    that.$router.push({path: "/antdetails/index", query: {id, [label.key]: [label.value], qywxUserId, ut_source: 'ai_heating',acc_id:account_id}});
                }else{
                    that.$router.push({path: "/project/detail/construction", query: {id, [label.key]: [label.value], qywxUserId, ut_source: 'ai_heating',acc_id: account_id}});
                }
            }
        },
        // 确认搜索
        confirm(click = 0) {
            const createStr = (arr) => {
                if (arr.length === 0) {
                    return "";
                }
                let str = arr.reduce((prev, curr, idx, arr) => {
                    return `${curr},${prev}`;
                }, "");
                return str.substring(0, str.lastIndexOf(","));
            };
            this.arrSearchConfig.forEach((item) => {
                switch (item.type) {
                    case "house_area":
                        this.oAttrValue.houseArea = createStr(item.checked);
                        break;
                    case "house_type":
                        this.oAttrValue.houseType = createStr(item.checked);
                        break;
                    case "house_cate":
                        this.oAttrValue.houseCate = createStr(item.checked);
                        break;
                    case "antType":
                        this.oAttrValue.typeId = createStr(item.checked);
                    case "plan":
                        this.oAttrValue.plan = createStr(item.checked);
                        break;
                    case "praise":
                        this.oAttrValue.praise = createStr(item.checked);
                        break;
                    case "decorate":
                        this.oAttrValue.decorate = createStr(item.checked);
                        break;
                }
            });

            // let { houseArea, houseType, houseCate, typeId, plan, decorate, praise } = this.oAttrValue
            // if (!houseArea && !houseType && !houseCate && !typeId &&　!plan　&&　!decorate && !this.sKeyWord) {
            //     this.$toast({
            //         message: "请先填写相关搜索信息",
            //         duration: 1500,
            //     });
            //     return false
            // }

            this.arrProjectList = [];
            this.nPage = 0;

            // if (click === 0) {
            //     this.closeSearchModal()
            // }
            //  console.log('搜索')
            this.getProjectList();
        },
        // 防抖
        debounce(func, delay) {
            let context = this; // this指向发生变化，需要提出来
            let args = arguments;
            return (function () {
                if (context.timer) {
                    clearTimeout(context.timer);
                }
                context.timer = setTimeout(() => {
                    func.apply(context, args);
                }, delay);
            })(); // 注意:我加了()
        },
        // 搜索事件触发
        searchChange() {
            this.debounce(() => {
                this.getProjectList();
            }, 500);
        },
        // 请求列表
        async getProjectList(callback) {
            //  console.log("列表")
            this.$store.commit("loadSwitch", true);
            let {houseArea, houseType, houseCate, typeId, plan, praise, decorate} =
                this.oAttrValue;

            const requestData = {
                houseArea,
                houseType,
                houseCate,
                typeId,
                plan,
                praise,
                decorate,
                cityId: this.nCityId,
                longitude: this.nLng,
                latitude: this.nLat,
                plotName: this.sKeyWord,
                page: this.nPage,
                is_all: this.isAll,
                row: 10,
            };
            const resultData = await getProjectList(requestData);
            this.$store.commit("loadSwitch", false);
            //  console.log(resultData,"请求列表数据-----------");
            this.nMore = resultData.data.data.result.is_recommend;
            this.arrProjectList = [
                ...this.arrProjectList,
                ...resultData.data.data.result.lists,
            ];
            this.noArrPro = true;
            if (this.arrProjectList.length == 0 || resultData.data.data.result.total == this.arrProjectList.length) {
                if(this.arrProjectList.length == 0){
                    this.noArrPro = false;
                }

                this.nPage = 0;
                this.arrProjectListOther = [] //周边案例
                this.getProjectListsOther(() => {
                    // loaded("done");
                    this.nPage++
                });
                //  console.log("进来没有数据")
            }

            // function compare(property){
            //     return function(a,b){
            //         var value1 = a[property];
            //         var value2 = b[property];
            //         return value2 - value1;//,降序为value2 - value1
            //     }
            // }
            // this.arrProjectList.sort(compare('state'))
            //  console.log(this.arrProjectList, "数据");
            this.isToEnd =
                resultData.data.data.result.total === this.arrProjectList.length
                    ? true
                    : false; // 到底不让请求了
            this.isNotData = this.arrProjectList.length === 0 ? true : false;
            if (resultData.data.data.result.lists.length == 0) {
                this.nPage = 0;
            }
            //  console.log("888888");
            callback && callback();
        },
        // 展示周边案例
        async getProjectListsOther(callback) {
            //  console.log('周边')
            let that = this;
            this.$store.commit("loadSwitch", true);
            let {houseArea, houseType, houseCate, typeId, plan, praise, decorate} =
                this.oAttrValue;
            const requestData = {
                houseArea,
                houseType,
                houseCate,
                typeId,
                plan,
                praise,
                decorate,
                cityId: this.nCityId,
                longitude: this.nLng,
                latitude: this.nLat,
                plotName: this.sKeyWord,
                page: this.nPage,
                is_all: this.isAll,
                row: 10,
            };
            this.topMore = true;
            const returnValue = await getProjectListsOther(requestData);
            // this.arrProjectList.push({type:1,text:'更多周边案例'})
            if ( returnValue.data.data.result.lists.length == 0) {
                //  console.log("数据为空");
                if(this.nPage == 1){
                    this.getProjectListsOtherEmpty()
                }
                //客户绝得周边案例太少，用全国数据
                // this.getProjectListsOtherEmpty()
            } else {
                this.arrProjectListOther = [
                    ...this.arrProjectListOther,
                    ...returnValue.data.data.result.lists,
                ];
            }

            if(returnValue.data.data.result.total == this.arrProjectListOther.length){
                this.rimNoData = false;
            }

            callback && callback();
            this.$store.commit("loadSwitch", false);
            //  console.log(returnValue, this.arrProjectListOther, "更多周边");
        },
        //周边数据为空时展示全部数据
        async getProjectListsOtherEmpty() {
            //  console.log("展示默认数据");
            this.$store.commit("loadSwitch", true);
            let {houseArea, houseType, houseCate, typeId, plan, praise, decorate} =
                this.oAttrValue;
            const requestData = {
                houseArea: "",
                houseType: "",
                houseCate: "",
                typeId: "",
                plan: "",
                praise: "",
                decorate: "",
                cityId: this.nCityId,
                longitude: this.nLng,
                latitude: this.nLat,
                plotName: this.sKeyWord,
                page: this.nPage,
                is_all: this.isAll,
                row: 10,
            };
            this.topMore = true;
            const returnValue = await getProjectListsOther(requestData)
            this.arrProjectListOther = returnValue.data.data.result.lists
            this.$store.commit("loadSwitch", false);
        },

        // 给父组件切换城市，调用接口显示案例列表
        async getProjectList2(data) {
            //  console.log('切换城市')
            this.arrProjectList = [];
            this.arrProjectListOther = []; //周边案例
            this.isToEnd = false;
            this.rimNoData = true;
            this.nPage = 0;
            this.$store.commit("loadSwitch", true);
            let {houseArea, houseType, houseCate, typeId, plan, praise, decorate} =
                this.oAttrValue;
            const requestData = {
                houseArea,
                houseType,
                houseCate,
                typeId,
                plan,
                praise,
                decorate,
                cityId: data.nCityId,
                longitude: data.nLng,
                latitude: data.nLat,
                plotName: this.sKeyWord,
                page: this.nPage,
                row: 10,
            };
            const resultData = await getProjectList(requestData);
            this.nMore = resultData.data.data.result.is_recommend;
            this.arrProjectList = [
                ...this.arrProjectList,
                ...resultData.data.data.result.lists,
            ];
            //  console.log(this.arrProjectList, '777777')
            // function compare(property){
            //     return function(a,b){
            //         var value1 = a[property];
            //         var value2 = b[property];
            //         return value2 - value1;//,降序为value2 - value1
            //     }
            // }
            // this.arrProjectList.sort(compare('state'))
            this.isToEnd =
                resultData.data.data.result.total === this.arrProjectList.length
                    ? true
                    : false; // 到底不让请求了
            this.$store.commit("loadSwitch", false);
            this.isNotData = this.arrProjectList.length === 0 ? true : false;
            if (this.isNotData) {
                this.arrProjectList = [];
                this.arrProjectListOther = []; //周边案例
                this.nPage = 0;
                this.noArrPro = false;
                this.getProjectList();
            } else {
                this.noArrPro = true;
            }
            if (resultData.data.data.result.lists.length != 0) {
                if (
                    resultData.data.data.result.lists[0].city == this.nCity ||
                    !this.nCity
                ) {
                    this.topMore = false;
                }
            } else {
                this.topMore = true;
                const returnValue = await getProjectListsOther(requestData);
                this.arrProjectList = [
                    ...this.arrProjectList,
                    ...returnValue.data.data.result.lists,
                ];
            }
        },
        // 获取搜索条件
        async getSearchConfig() {
            const resultData = await getSearchConfig();
            const data = resultData.data.data.result;
            this.arrSearchConfig.forEach((item) => {
                for (const key in data) {
                    if (key === item.type) {
                        item.tabList = data[key];
                    }
                }
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.case-list {
    margin-top: 120px;

    .list-wrap {
        height: calc(100vh - 120px);
        overflow: hidden;

        ul {
            padding: 30px;

            .top_more {
                margin-bottom: 20px;
                display: flex;
                align-items: center;
                justify-content: center;

                .leftBor {
                    width: 100px;
                    height: 2px;
                    background: linear-gradient(
                            90deg,
                            #ffffff 0%,
                            #8e8e8e 100%
                    );
                }

                .titleMore {
                    font-size: 28px;
                    color: #8e8e8e;
                    line-height: 68px;
                    padding: 0 16px;
                }

                .rightBor {
                    width: 100px;
                    height: 2px;
                    background: linear-gradient(
                            90deg,
                            #919191 0%,
                            #ffffff 100%
                    );
                }
            }

            .more {
                padding: 15px 0 15px 15px;
                border-bottom: 2px solid #ccc;
                font-size: 36px;
                font-weight: bold;
                margin-bottom: 15px;
            }

            li {
                overflow: hidden;
                border: 2px solid rgba(190, 201, 249, 0.3);
                border-radius: 20px;
                background-color: rgb(255, 255, 255);
                box-shadow: 0px 0px 30px 0px rgba(168, 183, 251, 0.4);
                width: 100%;
                padding: 25px;
                margin-bottom: 15px;
                position: relative;
                .koub-icon{
                    width: 88px;
                    position: absolute;
                    right: 0px;
                    top: 50px;
                }

                & > p {
                    width: 85%;
                    font-size: 36px;
                    color: rgb(45, 45, 45);
                    font-weight: bold;

                    span {
                        display: inline-block;
                        margin-right: 5px;
                        margin-left: 5px;
                    }
                }

                .attr {
                    margin-top: 10px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;

                    .attr-left {
                        display: flex;
                        align-items: center;

                        p {
                            font-size: 28px;
                            color: rgb(0, 0, 0);
                            margin-right: 30px;
                        }

                        .tag-list {
                            // margin-top: 15px;
                            display: flex;
                            align-items: center;

                            & > div {
                                border: 2px solid #c5d0ff;
                                background-color: #f2f7ff;
                                border-radius: 40px;
                                margin-right: 10px;
                                font-size: 24px;
                                color: rgb(67, 89, 187);
                                padding: 3px 20px;
                            }
                        }
                    }

                    .attr-right {
                        display: flex;
                        align-items: center;

                        img {
                            width: 29px;
                            height: 21px;
                            flex-shrink: 0;
                            margin-right: 15px;
                        }

                        span {
                            font-size: 28px;
                            color: rgba(45, 45, 45, 0.502);
                        }
                    }
                }

                .pic-list {
                    margin-top: 15px;
                    display: flex;
                    align-items: center;
                    // justify-content: space-between;
                    .pic-item {
                        img {
                            margin: 0 5px;
                            width: 198px;
                            height: 198px;
                            flex-shrink: 0;
                        }
                    }
                }

                .state-icon {
                    position: absolute;
                    top: 0;
                    right: 0;
                }

                .yqy {
                    background: url("~@/assets/images/ant/map/yqy.png") top/100% auto no-repeat;
                    width: 118px;
                    height: 41px;
                }

                .ywg {
                    background: url("~@/assets/images/ant/map/ywg.png") top/100% auto no-repeat;
                    width: 118px;
                    height: 41px;
                }

                .sgz {
                    background: url("~@/assets/images/ant/map/sgz.png") top/100% auto no-repeat;
                    width: 118px;
                    height: 41px;
                }

            }
        }

        .dropload-tip {
            text-align: center;
            font-size: 24px;
            padding: 10px 0;
            background-color: #fff;
            margin-top: 20px;
        }

        .not-data2 {
            margin-top: 30px;
            margin-bottom: 20px;
            text-align: center;
            font-size: 24px;
            height: 100%;
        }

        .not-data {
            text-align: center;
            font-size: 24px;
            height: 100%;
        }
    }

    .search-wrap-mask {
        width: 100%;
        height: 100%;
        position: fixed;
        left: 0;
        top: 120px;
        z-index: 1;
        background-color: rgba(0, 0, 0, 0.6);
    }

    .search-wrap {
        padding: 30px;
        border: 1px solid gb(190, 201, 249);
        // border-radius: 20px;
        background-color: rgb(255, 255, 255);
        box-shadow: 0px 0px 30px 0px rgba(168, 183, 251, 0.4);
        margin-bottom: 50px;

        .search {
            margin-bottom: 20px;

            span {
                font-size: 28px;
                color: rgba(45, 45, 45, 0.8);
            }

            input {
                margin-left: 15px;
                background-color: rgb(247, 247, 253);
                width: 479px;
                height: 75px;
                border-radius: 45px;
                padding: 5px 30px;
                font-size: 28px;
            }
        }

        .search-item {
            margin-top: 10px;
            display: flex;

            .label {
                width: 115px;
                margin-top: 10px;
                font-size: 28px;
                color: rgba(45, 45, 45, 0.8);
                flex-shrink: 0;
                text-align: right;
            }

            .tab-list {
                margin-left: 15px;
                // margin-top: 15px;
                display: flex;
                flex-wrap: wrap;

                .tab-item {
                    border-radius: 45px;
                    background-color: rgb(247, 247, 253);
                    font-size: 24px;
                    color: rgb(45, 45, 45);
                    padding: 0 18px;
                    min-width: 135px;
                    height: 62px;
                    line-height: 64px;
                    text-align: center;
                    margin-right: 13px;
                    margin-bottom: 15px;
                }

                .active {
                    color: rgb(92, 119, 240);
                    background-color: #eaf1ff;
                }
            }
        }

        .btn {
            display: flex;
            justify-content: space-between;

            & > button:nth-child(1) {
                width: 290px;
                height: 80px;
                font-size: 30px;
                color: rgb(67, 67, 67);
                border: 2px solid rgba(125, 125, 125, 0.8);
                border-radius: 45px;
                background-color: #fff;
                outline: none;
            }

            & > button:nth-child(2) {
                width: 290px;
                height: 80px;
                background-color: #5c77f0;
                border-radius: 45px;
                color: #fff;
                font-size: 30px;
                outline: none;
            }
        }
    }
}

.collapse-enter-active {
    transition: all 0.8s ease;
}

.collapse-leave-active {
    transition: all 0.8s ease;
}

.collapse-enter,
.collapse-leave-to {
    transform: translateY(1450px);
}

.collapse-list-enter-active {
    transition: all 0.5s ease;
}

.collapse-list-leave-active {
    transition: all 0.5s ease;
}

.collapse-list-enter,
.collapse-list-leave-to {
    transform: translateY(-1450px);
}

@keyframes fadeIn {
    0% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
}

@keyframes fadeOut {
    0% {
        opacity: 1;
    }

    100% {
        opacity: 0;
    }
}
</style>
